<template>
  <div class="page">
    <a-card :bordered="false" :bodyStyle="{paddingTop:'10px'}">
      <Breadcrumb routeName="HomeSetting" toName="添加新内容" :cneterName="homeModularName"
                  goPathName="首页推荐位"></Breadcrumb>
      <a-form :form="form">
        <a-form-item label="内容类型" v-bind="formItemLayout">
          <a-radio-group v-decorator="['modularContentType']" @change="onChange">
            <a-radio :value="0">商品</a-radio>
            <a-radio :value="1" v-if="modularClassId==0">链接</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item :label="modularClassId==0?'轮播图片/视频':'封面图片/视频'" v-bind="formItemLayout" required>
          <a-upload
            name="file"
            accept="image/jpeg,image/png,image/gif,video/*"
            :multiple="false"
            :action="uploadFileUrl"
            :fileList="fileList"
            :limit="1"
            :disabled="videoUploading"
            @change="handleBusinessLicenseChange"
            :before-upload="handleBeforeUploadMedia"
            v-decorator="[
            'uploadImage',
            {rules: [{ required: true, message: '请上传图片或视频' }]}
          ]"
          >
            <a-button :loading="videoUploading">
              <a-icon type="upload"/>
              {{ videoUploading ? '上传中...' : '上传文件' }}
            </a-button>
            <span class="pl10"
                  v-if="modularClassId==0">温馨提示：图片建议上传尺寸为750px*326px，格式.jpg、.png、.jpeg，也可上传视频</span>
            <span class="pl10" v-else>温馨提示：图片上传尺寸为 800*600，格式.jpg、.png、.jpeg，也可上传视频</span>
          </a-upload>
        </a-form-item>
        <a-form-item label="标题" v-bind="formItemLayout">
          <a-input placeholder="请输入" style="max-width:500px" :maxLength="30"
                   v-decorator="['modularDetailTitle', { rules: [{ required: true, message: '请输入标题' },,{ min: 1, max: 30, message: '标题30字内', trigger: 'blur' }] }]"
          />
        </a-form-item>
        <a-form-item label="投放时间" v-bind="formItemLayout">
          <a-range-picker name="buildTime" @change="onDateChange" show-time
                          :format="formatDate" :disabledDate="disabledDate" v-decorator="[
            'buildTime', {rules: [{ required: true, message: '请选择起止日期' }]}]"/>
        </a-form-item>
        <a-form-item label="关联商品" v-if="type==0" v-bind="formItemLayout">
          <a-button @click="showModel" v-decorator="[
            'productBtn',
            {rules: [{ required: true, message: '请选择商品' }]}
          ]">选择
          </a-button>
          <span v-if="proId">&nbsp;&nbsp;商品ID：{{ proId }}</span>
        </a-form-item>
        <a-form-item label="链接" v-if="type==1" v-bind="formItemLayout">
          <a-input placeholder="小程序仅支持安全域名下的链接" style="max-width:500px"
                   v-decorator="['interlinkage', { rules: [{ required: true, message: '请输入链接', },{pattern: /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/, message: '请输入正确网络链接',}]}]"
          />
        </a-form-item>
        <a-form-item v-bind="formItemLayoutBtn">
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading">保存</a-button>
        </a-form-item>
      </a-form>
    </a-card>
    <!-- 商品组件弹窗 -->
    <ProductPopupView :visible="visiblePopup" @change="changeSelectPro" @cancel="handleCancel"></ProductPopupView>
  </div>
</template>

<script>
import Breadcrumb from '@/customComponents/Breadcrumb/Breadcrumb'
import formMixins from '../../../utils/mixins/formMixins'
import ossUploadMixins from '@/utils/mixins/ossUploadMixins'
import ProductPopupView from '@/customComponents/productPopupView/productPopupView'
import { getQueryString } from '@/utils/common.js'
import { addDate } from '@/utils/common.js'
import moment from 'moment'

export default {
  name: 'AddNewContent',
  mixins: [formMixins, ossUploadMixins],
  components: {
    Breadcrumb,
    ProductPopupView
  },
  data() {
    return {
      moment,
      type: 0,
      visiblePopup: false,
      submitLoading: false,
      homeModularId: this.$route.query.homeModularId,
      modularDetailId: this.$route.query.modularDetailId,
      homeModularName: this.$route.query.homeModularName,
      modularClassId: this.$route.query.modularClassId,
      modularDetailStartTime: this.getDateHelper().getCurrentFormatDate('YYYY-MM-DD HH:mm:ss'),
      modularDetailEndTime: this.getDateHelper().formatDate(moment().add(30, 'days'), 'YYYY-MM-DD HH:mm:ss'),
      fileList: [],
      imageUrl: '',
      videoUploading: false,
      maxVideoSize: 200,
      proId: '',
      formatDate: 'YYYY-MM-DD HH:mm:ss',
      disabledDate(current) {
        // Can not select days before today and today
        return current && current < moment().startOf('day')
      }
    }
  },
  activated() {
    this.getLogUtils().logWithTag('获取图片上传路径', this.$store.getters.appConfig.baseUrl)
    this.getNewData()
  },
  mounted() {

  },
  methods: {
    // 重新获取数据
    getNewData() {
      this.homeModularId = this.$route.query.homeModularId
      this.modularDetailId = this.$route.query.modularDetailId
      this.homeModularName = this.$route.query.homeModularName
      this.modularClassId = this.$route.query.modularClassId
      this.getLogUtils().logWithTag('homeModularName', this.homeModularName)
      if (this.modularDetailId != 0) {
        this.getHomeModularDetail()
      } else {
        this.fileList = []
        this.imageUrl = ''
        this.proId = ''
        this.type = 0
        this.visiblePopup = false
        this.modularDetailStartTime = this.getDateHelper().getCurrentFormatDate('YYYY-MM-DD HH:mm:ss')
        this.modularDetailEndTime = this.getDateHelper().formatDate(moment().add(30, 'days'), 'YYYY-MM-DD HH:mm:ss')
        this.form.setFieldsValue({
          modularContentType: 0,
          uploadImage: undefined,
          modularDetailTitle: undefined,
          buildTime: [moment(new Date(), this.dateFormat), moment(moment().add(30, 'days'), this.dateFormat)],
          productBtn: undefined
        })
        this.getLogUtils().logWithTag('modularDetailStartTime', this.modularDetailStartTime)
        this.getLogUtils().logWithTag('modularDetailEndTime', this.modularDetailEndTime)
      }
    },
    // 获取数据
    getHomeModularDetail() {
      this.getHttpServices().getUserService().post('homepage/recommend/get/modularDetail', {
        homeModularDetailId: this.modularDetailId
      }).then(res => {
        this.getLogUtils().logWithTag('==getHomeModularDetail==', res)
        if (res.modularContentType == 0) {
          this.type = 0
          setTimeout(() => {
            this.form.setFieldsValue({
              productBtn: res.modularDetailLinked
            })
          }, 300)
          this.proId = res.modularDetailLinked
        } else if (res.modularContentType == 1) {
          this.type = 1
          setTimeout(() => {
            this.form.setFieldsValue({
              interlinkage: res.modularDetailLinked
            })
          }, 300)
        }
        this.fileList = [
          {
            uid: '-1',
            name: res.modularDetailImg,
            status: 'done',
            url: res.modularDetailImg
          }
        ]
        this.imageUrl = res.modularDetailImg
        this.modularDetailStartTime = res.modularDetailStartTime
        this.modularDetailEndTime = res.modularDetailEndTime
        this.form.setFieldsValue({
          modularContentType: res.modularContentType,
          modularDetailTitle: res.modularDetailTitle,
          buildTime: this.getDateHelper().getDateMoments(res.modularDetailStartTime, res.modularDetailEndTime),
          uploadImage: this.fileList
        })
        this.getLogUtils().logWithTag('this.type', this.type)
        this.getLogUtils().logWithTag('this.fileList', this.fileList)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    showModel() {
      this.visiblePopup = true
    },
    onChange(e) {
      this.getLogUtils().logWithTag('radio checked', e.target.value)
      this.type = e.target.value
    },
    handleSubmit(e) {
      this.validateFormParams().then(res => {
        this.getLogUtils().logWithTag('handleSubmit', res)
        let params = new Object()
        params.homeModularId = this.homeModularId
        params.modularContentType = res.modularContentType
        params.modularDetailEndTime = this.modularDetailEndTime
        params.modularDetailId = this.modularDetailId
        params.modularDetailImg = this.imageUrl
        params.modularDetailLinked = res.modularContentType == 0 ? res.productBtn : res.interlinkage
        if (res.modularContentType == 0) {
          params.modularDetailParamLinked = null
          params.modularDetailParamLinkedType = null
        } else {
          this.getLogUtils().logWithTag('==interlinkage==', res.interlinkage)
          let url = new URL(res.interlinkage)

          if (getQueryString('subjectMerchantId', url) != null) {
            this.getLogUtils().logWithTag(getQueryString('subjectMerchantId', url))
            params.modularDetailParamLinked = getQueryString('subjectMerchantId', url)
            params.modularDetailParamLinkedType = 2
          } else if (getQueryString('proId', url) != null) {
            this.getLogUtils().logWithTag(getQueryString('proId', url))
            params.modularDetailParamLinked = getQueryString('proId', url)
            params.modularDetailParamLinkedType = 1
          } else {
            params.modularDetailParamLinked = null
            params.modularDetailParamLinkedType = null
          }
        }
        this.getLogUtils().logWithTag('==interlinkage==', res.interlinkage)
        params.modularDetailStartTime = this.modularDetailStartTime
        params.modularDetailTitle = res.modularDetailTitle
        this.getLogUtils().logWithTag('保存表单数据', params)
        this.submitLoading = true
        this.getHttpServices().getUserService().post('homepage/recommend/save/modularDetail', params)
          .then(res => {
            this.getLogUtils().logWithTag('==handleSubmit==', res)
            this.$message.success('内容保存成功')
            this.$router.push({
              name: 'HomeSetting',
              query: {
                updateFlag: 1
              }
            })
          }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
      })
    },
    //上传图片
    handleBusinessLicenseChange(file) {
      this.getLogUtils().logWithTag('handleBusinessLicenseChange', file)
      if (file.file.status != 'removed') {
        this.fileList = [...file.fileList]
        this.fileList = this.fileList.slice(-1)
        this.fileList.forEach(file => {
          // 因为只有一个，所以可以用
          if (file.response) {
            this.imageUrl = file.response.data
          }
        })
      } else {
        this.fileList = []
        this.imageUrl = ''
        setTimeout(() => {
          this.form.setFieldsValue({
            uploadImage: undefined
          })
        }, 300)
      }
      this.getLogUtils().logWithTag('this.fileList', this.fileList)
      this.getLogUtils().logWithTag('imageUrl', this.imageUrl)
    },
    //日期
    onDateChange(dates, dateStrArr) {
      this.getLogUtils().logWithTag('onDateChange', dates)
      this.getLogUtils().logWithTag('onDateChange', dateStrArr)
      this.modularDetailStartTime = dateStrArr[0]//出游开始日期
      this.modularDetailEndTime = dateStrArr[1]//出游结束日期
    },
    // 删除图片
    removeImage(file) {
      this.getLogUtils().logWithTag('removeImage', file)
      if (file.status == 'removed') {
        this.form.setFieldsValue({
          uploadImage: undefined
        })
        this.fileList = []
        this.imageUrl = ''
      }
    },
    // 选择商品
    changeSelectPro(item) {
      this.getLogUtils().logWithTag('选择商品', item)
      this.proId = item.proId
      this.handleCancel()
      let modularDetailTitle = this.form.getFieldValue('modularDetailTitle')
      let uploadImage = this.form.getFieldValue('uploadImage')
      this.getLogUtils().logWithTag('modularDetailTitle', modularDetailTitle)
      if (!modularDetailTitle) {
        this.form.setFieldsValue({
          modularDetailTitle: item.proName.substr(0, 30)
        })
      }
      if (!uploadImage) {
        this.fileList = [
          {
            uid: '-1',
            name: item.proImg,
            status: 'done',
            url: item.proImg
          }
        ]
        this.form.setFieldsValue({
          uploadImage: this.fileList
        })
        this.imageUrl = item.proImg
      }
      this.form.setFieldsValue({
        productBtn: this.proId
      })
    },
    handleCancel() {
      this.visiblePopup = false
    },
    setUploadResult(url, fileName) {
      this.imageUrl = url
      this.fileList = [
        {
          uid: '-1',
          name: fileName || url,
          status: 'done',
          url: url
        }
      ]
      this.form.setFieldsValue({
        uploadImage: this.fileList
      })
    },
    // 图片走旧接口，视频走 OSS 直传
    handleBeforeUploadMedia(file) {
      this.getLogUtils().logWithTag('handleBeforeUploadMedia', file)
      if (this.isVideoFile(file)) {
        if (!this.validateVideoSize(file, this.maxVideoSize)) {
          return false
        }
        this.handleOssVideoUpload(file, (fileUrl, uploadFile) => this.setUploadResult(fileUrl, uploadFile.name))
        return false
      }
      return this.handleBeforeUploadImage(file)
    }
  }

}
</script>
<style lang="less">
@import url('../../CustomPage.less');

.heading {
  font-size: 20px;
  font-weight: 400;
  color: #000;
}

.pl10 {
  padding-left: 10px;
}
</style>